import { useState } from "react";

const usePopover = (): [boolean, () => void, () => void] => {
  const [isShow, setIsShow] = useState(false);

  const show = () => {
    setIsShow(true);
  };
  const hide = () => {
    setIsShow(false);
  };

  return [isShow, show, hide];
};

export default usePopover;
